import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=405032d1&scoped=true"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"
import style0 from "./PreFooter.vue?vue&type=style&index=0&id=405032d1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405032d1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/elements/Button.vue').default})
